/**
 * Badge Component — Premium Global Badges
 * Refined styling with luxury color palette & Tooltips
 */
import React from 'react';
import { Star, Award, Leaf, Wheat, ThumbsUp, CheckCircle, HelpCircle } from 'lucide-react';

export function Badge({ type, t, onClick, size = 'md', className = '' }) {
  const styles = {
    michelin: {
      bg: 'bg-gradient-to-r from-amber-50 to-yellow-50',
      text: 'text-amber-800',
      border: 'border-amber-200/50',
      icon: <Star size={12} fill="currentColor" />,
      labelKey: 'michelinGuide'
    },
    shell_chuan_chim: {
      bg: 'bg-gradient-to-r from-emerald-50 to-emerald-100',
      text: 'text-emerald-800',
      border: 'border-emerald-200/50',
      icon: <Award size={12} />,
      labelKey: 'Shell Chuan Chim'
    },
    perp_pitsadarn: {
      bg: 'bg-gradient-to-r from-violet-50 to-violet-100',
      text: 'text-violet-800',
      border: 'border-violet-200/50',
      icon: <ThumbsUp size={12} />,
      labelKey: 'Perp Pitsadarn'
    },
    vegan: {
      bg: 'bg-gradient-to-r from-emerald-50 to-emerald-100',
      text: 'text-emerald-700',
      border: 'border-emerald-200/50',
      icon: <Leaf size={12} />,
      labelKey: 'vegan'
    },
    halal: {
      bg: 'bg-gradient-to-r from-blue-50 to-cyan-50',
      text: 'text-blue-700',
      border: 'border-blue-200/50',
      icon: <CheckCircle size={12} />,
      labelKey: 'halal'
    },
    glutenFree: {
      bg: 'bg-gradient-to-r from-coral-50 to-coral-100',
      text: 'text-coral-700',
      border: 'border-coral-200/50',
      icon: <Wheat size={12} />,
      labelKey: 'glutenFree'
    }
  };

  const style = styles[type] || {
    bg: 'bg-slate-50',
    text: 'text-slate-600',
    border: 'border-slate-200/50',
    icon: <HelpCircle size={12} />,
    labelKey: type
  };

  const label = t ? t(style.labelKey) : style.labelKey;

  const sizeClasses = {
    sm: 'p-1',
    md: 'p-1.5',
    lg: 'p-2'
  };

  return (
    <div className="group/badge relative inline-flex">
      <span
        onClick={onClick}
        className={`inline-flex items-center justify-center rounded-full border ${style.bg} ${style.text} ${style.border} ${sizeClasses[size]} ${onClick ? 'cursor-pointer hover:scale-110 transition-transform duration-400 ease-spring hover:shadow-soft' : ''} ${className}`}
        title={label}
      >
        {style.icon}
      </span>

      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-slate-900 text-white text-[12px] font-medium rounded-xl opacity-0 invisible group-hover/badge:opacity-100 group-hover/badge:visible transition-all duration-300 ease-spring transform group-hover/badge:-translate-y-1 translate-y-1 whitespace-nowrap z-10 shadow-spring pointer-events-none text-center">
        {label}
        {onClick && (
          <div className="text-[9px] text-neutral-400 mt-0.5 font-normal">
            Click to learn more
          </div>
        )}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-neutral-900"></div>
      </div>
    </div>
  );
}

export default Badge;
